import { ColumnsType, SortOrder } from 'antd/lib/table/interface'
import { PendingCategory } from 'components/Forms/forms.user.d'
import { Sorter } from 'components/Sorter/Sorter'
import { LABELS } from 'constants/txt'

export const columns: ColumnsType<PendingCategory> = [
  {
    dataIndex: 'name',
    key: 'name',
    width: 'calc(100% - 40px)',
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<PendingCategory>
        dataIndex="name"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        {LABELS.CONTRACT_CATEGORY}
      </Sorter>
    ),
    sorter: (a, b) => a.name?.localeCompare(b.name ?? ''),
    showSorterTooltip: false
  }
]
